import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSession } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    exchangeSession(session_id)
      .then((data) => {
        setUser(data.user);
        // Clear the hash and go to dashboard
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true, state: { user: data.user } });
      })
      .catch(() => {
        navigate("/login", { replace: true });
      });
  }, [navigate, setUser]);

  return (
    <div className="h-screen flex items-center justify-center font-display">
      <div className="text-2xl font-extrabold">Signing you in…</div>
    </div>
  );
}
